import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NotificationsListener } from '@/app/platform/platform-core/platform-notifications/listeners/notifications-listener';
import { PAnnouncementComponent } from './components/p-announcement/p-announcement.component';
import { PAnnouncementBannerComponent } from './components/p-announcement/p-announcement-banner.component';
import { SharedModule } from '@shared/shared.module';
import { NotificationLevelColorPipe } from './pipes/notification-level-color.pipe';

@NgModule({
  declarations: [PAnnouncementComponent, PAnnouncementBannerComponent, NotificationLevelColorPipe],
  imports: [CommonModule, SharedModule],
  exports: [PAnnouncementComponent, PAnnouncementBannerComponent],
  providers: [NotificationsListener]
})
export class PlatformNotificationsModule {}
